import React from 'react';
import cn from 'classnames';
import { Trans, useTrans } from 'base/utils/i18n'
import { HtmlRender } from '@base/snippets/HtmlRender'

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

type IProps = {
    className?: string
}

const Rules: React.FC<IProps> = (props) => {

    const { className } = props
    const { t } = useTrans();

    return (
        <div id={'js-early-access-rules'} className={cn(className)}>
            <div className={'g-container'}>
                <HtmlRender
                    html={t('web_early_access_rules')}
                />

            </div>
        </div>
    );
};

export default Rules